import ScrollResetter from './ScrollResetter'

export default ScrollResetter
